// extracted by mini-css-extract-plugin
export default {"content":"AgreementPage_content__FYipD","page_title":"AgreementPage_page_title__72S-A","page_text":"AgreementPage_page_text__mWhrp"};